import React from "react";
import PlatformLayout from "../../components/platform/PlatformLayout";
import { PlatformZone } from "../../components/platform/PlatformZone";

const Policies: React.FC = () => {

 return (
  <PlatformLayout>
   {/* Hero Section - Editable Zone */}
   <PlatformZone pageSlug="policies" zoneName="hero" />

   {/* Platform Info Section - Editable Zone */}
   <PlatformZone pageSlug="policies" zoneName="info" />

   {/* Policies List - Editable Zone */}
   <PlatformZone pageSlug="policies" zoneName="policies" />

   {/* Questions Section - Editable Zone */}
   <PlatformZone pageSlug="policies" zoneName="questions" />

   {/* CTA Section - Editable Zone */}
   <PlatformZone pageSlug="policies" zoneName="cta" />
  </PlatformLayout>
 );
};

export default Policies;

